import FirebaseService from "./firebase/FirebaseService";
import { currentUserEmail, currentUserId } from "../App";

// TODO: Add user id, class id, teacher id, etc... to these
class LogService {
  static information(func: string, message: string): void {
    console.log("information", func, message);
    FirebaseService.log("information", func, message, "", 1, "", currentUserId, currentUserEmail).catch(ex => {
      console.log(`Failed to log to server ${ex}`);
    });
  }

  static warning(func: string, message: string): void {
    console.log("warning", func, message);
    FirebaseService.log("warning", func, message, "", 2, "", currentUserId, currentUserEmail).catch(ex => {
      console.log(`Failed to log to server ${ex}`);
    });
  }

  private static exception_helper(func: string, message: string, exception: string, stack: string | undefined): void {
    console.log("error", func, `${message}\n ${exception}\n ${stack}`);
    FirebaseService.log("error", func, message, stack ?? "", 3, exception, currentUserId, currentUserEmail).catch(
      ex => {
        console.log(`Failed to log to server ${ex}`);
      },
    );
  }

  static exception(error: unknown, callerName: string, customMessage = ""): void {
    if (error instanceof Error) {
      const { message, stack } = error;
      LogService.exception_helper(callerName, customMessage, message, stack);
    } else if (typeof error === "string") {
      LogService.exception_helper(callerName, customMessage, error, "");
    } else if (error instanceof Object) {
      LogService.exception_helper(callerName, customMessage, JSON.stringify(error), "");
    }
  }

  static debug(func: string, message: string): void {
    console.log("debug", func, message);
    FirebaseService.log("debug", func, message, "", 0, "", currentUserId, currentUserEmail).catch(ex => {
      console.log(`Failed to log to server ${ex}`);
    });
  }
}

export default LogService;
